// extracted by mini-css-extract-plugin
module.exports = {"hero":"mirmeda-module--hero--LdwtO","heroContent":"mirmeda-module--heroContent--2Ti8w","heroBg":"mirmeda-module--heroBg--2Z-W0"};